import { Box, Chip, TableCell, TableRow } from "@mui/material";
import {
  ContainerCopyCell,
  NormalText,
  RowStyled,
  TableBodyStyled,
  TableCellStyled,
  TableHeadStyled,
  TableStyled,
  TooltipStyled,
} from "../../shared/styles";
import { ClipLoader } from "react-spinners";
import {
  copyToClipboard,
  formatDate,
  formatLargeText,
  getTokenIcon,
} from "../../shared/utils";
import { Copy } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

export const TablePortalTransactions = ({
  transactions,
  isLoadingTransactions,
  isErrorTransactions,
}) => {
  const navigate = useNavigate();

  const handleGoToTransactionDetail = (transactionId) => {
    navigate(`/transactions/${transactionId}`);
  };

  return (
    <TableStyled>
      <TableHeadStyled>
        <TableRow>
          <TableCell align="center">Transaction ID</TableCell>
          <TableCell align="center">From</TableCell>
          <TableCell align="center">To</TableCell>
          <TableCell align="center">Date</TableCell>
          <TableCell align="center">Amount</TableCell>
          <TableCell align="center">Currency</TableCell>
        </TableRow>
      </TableHeadStyled>
      <TableBodyStyled>
        {isLoadingTransactions ? (
          <TableRow>
            <TableCell colSpan={6} align="center">
              <ClipLoader loading={true} size={24} color="#0197f6" />
            </TableCell>
          </TableRow>
        ) : transactions?.length ? (
          transactions?.map((row) => (
            <RowStyled
              key={row.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                transition: "background-color 0.3s ease",
                "&:hover": {
                  cursor: "pointer",
                  backgroundColor: "#E3F3FD",
                },
              }}
              onClick={() => handleGoToTransactionDetail(row?.signedtx)}
            >
              <TableCellStyled align="center">
                <ContainerCopyCell>
                  <TooltipStyled title={row?.signedtx || "-"}>
                    {formatLargeText(row?.signedtx || "-", 40)}
                  </TooltipStyled>
                  <TooltipStyled title="Copy" placement="top" withCopy>
                    <Copy
                      color={"#8C8C8C"}
                      size={16}
                      onClick={() => copyToClipboard(row?.signedtx || "-")}
                    />
                  </TooltipStyled>
                </ContainerCopyCell>
              </TableCellStyled>
              {/* <TableCellStyled align="center">
                <Chip
                  label={row.status || "-"}
                  sx={{
                    color: row.status === "finalized" ? "#118FF0" : "#FF0000",
                    fontWeight: "bold",
                    fontSize: "12px",
                    borderRadius: "8px",
                    border: `1px solid ${
                      row.status === "finalized" ? "#118FF0" : "#FF0000"
                    }`,
                    backgroundColor: "#F5F5F5",
                  }}
                />
              </TableCellStyled> */}
              <TableCellStyled align="center">
                <ContainerCopyCell>
                  <TooltipStyled title={row?.from || "-"}>
                    {formatLargeText(row?.from || "-", 40)}
                  </TooltipStyled>
                  <TooltipStyled title="Copy" placement="top" withCopy>
                    <Copy
                      color={"#8C8C8C"}
                      size={16}
                      onClick={() => copyToClipboard(row?.from || "-")}
                    />
                  </TooltipStyled>
                </ContainerCopyCell>
              </TableCellStyled>
              <TableCellStyled align="center">
                <ContainerCopyCell>
                  <TooltipStyled title={row?.to || "-"}>
                    {formatLargeText(row?.to || "-", 40)}
                  </TooltipStyled>
                  <TooltipStyled title="Copy" placement="top" withCopy>
                    <Copy
                      color={"#8C8C8C"}
                      size={16}
                      onClick={() => copyToClipboard(row?.to || "-")}
                    />
                  </TooltipStyled>
                </ContainerCopyCell>
              </TableCellStyled>{" "}
              <TableCellStyled align="center">
                {formatDate(row.created_at)}
              </TableCellStyled>
              <TableCellStyled align="center">
                <NormalText style={{ width: "100%" }}>{row?.amount}</NormalText>
              </TableCellStyled>
              <TableCellStyled align="center">
                <Box
                  display={"flex"}
                  gap={"4px"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  {getTokenIcon(row?.token) && (
                    <img
                      src={getTokenIcon(row?.token)}
                      alt={row?.token}
                      style={{ width: 24, height: 24 }}
                    />
                  )}
                  <NormalText color={"#0f110b"} isBold>
                    {row?.token}
                  </NormalText>
                </Box>
              </TableCellStyled>
            </RowStyled>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={6}>
              <h5>
                {isErrorTransactions
                  ? "Error al cargar las transacciones"
                  : "No hay información para mostrar"}
              </h5>
            </TableCell>
          </TableRow>
        )}
      </TableBodyStyled>
    </TableStyled>
  );
};
